<template>
<card class="signup-type">
<div class="media">
  <div class="media-left is-relative">
    <himage size="is-64x64" :src="icon" />
  </div>
</div>
<h2 class="title is-6 text-overflow">{{ title }}</h2>
<h4 class="subtitle is-7">{{ subtitle }}</h4>
<p class="desc">{{ desc }}</p>
<button class="btnSelect button is-primary"
@click.prevent="onSelectType">
Select
</button>
</card>
</template>

<script>
import Card from '@/components/general/card'
import Himage from '@/components/general/image'

export default {
  components: {
    Card,
    Himage
  },
  props: {
    selType: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    desc: {
      type: String,
      required: true
    }
  },
  methods: {
    onSelectType () {
      this.$emit('select-type', this.selType)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.signup-type {
  cursor: pointer;
  height: 281px;
}

.signup-type:hover {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
}

.desc {
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #111111;
}

@media screen and (max-width: $tablet) {
.signup-type {
  height: 260px;
}
}

.btnSelect {
  position: absolute;
  bottom: 16px;
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/signup/signup-type-card.vue